"use client"

import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface LoaderContextType {
  isLoaderVisible: boolean;
  hideLoader: () => void;
  loaderType: 'initial' | 'welcome';
}

const LoaderContext = createContext<LoaderContextType | undefined>(undefined);

export function LoaderProvider({ children }: { children: ReactNode }) {
  const [isLoaderVisible, setIsLoaderVisible] = useState(false);
  const [loaderType, setLoaderType] = useState<'initial' | 'welcome'>('initial');

  // Show initial loader only once per session, not on every page
  useEffect(() => {
    const hasShownInitialLoader = sessionStorage.getItem('initial_loader_shown')
    
    if (!hasShownInitialLoader) {
      console.log('LoaderProvider: Showing initial loader for new session')
      setIsLoaderVisible(true)
      setLoaderType('initial')
      
      // Basic initial load timer
      const timer = setTimeout(() => {
        setIsLoaderVisible(false)
        sessionStorage.setItem('initial_loader_shown', 'true')
      }, 2000)

      return () => clearTimeout(timer)
    } else {
      console.log('LoaderProvider: Skipping initial loader - already shown this session')
      setIsLoaderVisible(false)
    }
  }, [])

  const hideLoader = () => {
    setIsLoaderVisible(false);
  };

  return (
    <LoaderContext.Provider value={{ isLoaderVisible, hideLoader, loaderType }}>
      {children}
    </LoaderContext.Provider>
  );
}

export function useLoader() {
  const context = useContext(LoaderContext);
  if (context === undefined) {
    throw new Error('useLoader must be used within a LoaderProvider');
  }
  return context;
}